import React from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/Logo.css';

const Logo = (): JSX.Element => {
  const { t } = useTranslation();
  return (
    <div className="logo-aspirion" aria-label={t('welcome.logoAlt')}>
      <img
        src={`${process.env.PUBLIC_URL}/aspirion-logo.png`}
        alt={t('welcome.logoAlt')}
        className="logo-image"
      />
    </div>
  );
};

export default Logo;
